export const API_BASE_URL = {
  main: process.env.REACT_APP_WEBTRANS_API_URL || 'https://localhost:44375/api/v1',
  secondary: process.env.REACT_APP_CONTAINERCONTROL_API_URL || 'https://localhost:44383/api/v1',
  genericentity: process.env.REACT_APP_GENERICENTITY_API_URL || 'http://localhost:5271/api/v1',
}
